import axios from 'axios';

export default async (id) => {
  const result = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/cases/find-by-entity-id/${id}`);
  return result.data;
};
